import React, { useEffect, useState } from 'react';
import './style.css';

const ProcessingSnackbar = ({ show, processingComplete, setProcessingComplete, setShowProcessingModal }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [errorStatus, setErrorStatus] = useState(false);

    // Handle successful completion
    useEffect(() => {
        if (processingComplete) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                setTimeout(() => {
                    setShowProcessingModal(false);
                    setProcessingComplete(false);
                }, 800);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [processingComplete]);

    // Handle timeout error
    useEffect(() => {
        if (show && !processingComplete) {
            const timeoutTimer = setTimeout(() => {
                setErrorStatus(true);
                // Start fade out process
                setTimeout(() => {
                    setIsVisible(false);
                    setTimeout(() => {
                        setShowProcessingModal(false);
                        setProcessingComplete(false);
                    }, 800);
                }, 3000);
            }, 30000);

            return () => clearTimeout(timeoutTimer);
        }
    }, [show]);

    if (!show) return null;

    return (
        <div className={`processing-snackbar 
            ${processingComplete ? 'bounce' : ''} 
            ${!isVisible ? 'hide' : ''} 
            ${errorStatus ? 'error' : ''}`}
        >
            {errorStatus ? (
                <span>Error, please try again</span>
            ) : !processingComplete ? (
                <>
                    <span>Processing data changes</span>
                    <span className="animated-dots">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                    </span>
                </>
            ) : (
                <span>Processing Complete!</span>
            )}
        </div>
    );
};

export default ProcessingSnackbar;
